import { Typography } from '@mui/material';
import { useAppSelector } from 'api';
import { IpaTable } from './IpaTable';
import { PageContainer } from 'app';

export const IpaPage = () => {
  const { currentMenuItem } = useAppSelector(state => state.menuItem);

  return (
    <PageContainer>
      <Typography variant="subtitle1">{currentMenuItem?.text}</Typography>
      <IpaTable />
    </PageContainer>
  );
};
